<template>
  <div class="row row-cols-8 row-cols-md-6  g-4 m-2">
    <div class="col" v-for="(r) in routes" :key="r">
      <div class="card h-100" style="width: 18rem;">
        <div class="card-body">
          <a v-bind:href="getLink(r)">
            <h5 class="card-title">{{ r.name }}</h5>
          </a>

          <p class="card-text">{{ r.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swagger-ui/dist/swagger-ui.css';

export default {
  data() {
    return {
      routes: [{
        name: String,
        endpoint: String,
        description: String,
        private: String,
        parts: [
          {
            name: String,
            endpoint: String
          }
        ]
      }]
    }
  },
  methods: {
    getLink(r){
      let branch = this.$route.params.branch;
      return branch
          ? '/branch/' + branch + '/' + r.endpoint + '/' + r.parts[0].endpoint
          : '/' + r.endpoint + '/' + r.parts[0].endpoint
    }
  },
  async created() {
    let branch = this.$route.params.branch;
    let conf_path = branch
        ? '/branch/' + branch + '/swagger_conf.json'
        : '/swagger_conf.json'
    let routes = await fetch(conf_path)
        .then(r => r.json())
    this.routes = routes.routes;
  }
}
</script>